/**
 * The canonical viewport breakpoints — import these rather than inlining a
 * width. Each is named for the range it caps, so a smaller value can still read
 * like a larger tier; the names predate the ladder and match the SCSS variables.
 *
 * They live here rather than on `useScreenSize` because specs routinely
 * `vi.mock` that module, which would leave a constant imported from it
 * undefined and silently disable whatever it gates.
 */
export const MOBILE_SMALL_BREAKPOINT = 600;
export const MOBILE_BREAKPOINT = 800; //this is equivalent to $mobile-breakpoint
export const TABLET_BREAKPOINT = 1160; //this is the same as $tablet-breakpoint
